import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';

export const isValidUserGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const { user } = inject(AuthenticationService);

  if (!user) {
    return false;
  }

  // The auth app's login runs the pending email validation challenge, then comes back to the navigation target.
  if (!user.isValid) {
    inject(AuthAppRedirectService).login(state.url);
    return false;
  }

  return true;
};
